/**
 * @typedef {object} AccessTokenJSON Access token JSON
 * @property {string} access
 * @property {string} user_id
 * @property {number} exp
 * @property {string} jti
 *
 * @typedef {object} AccessTokenData Access token JSON
 * @property {Date} expires
 * @property {string} userId
 *
 */

/**
 * Node.js atob polyfill
 * @param {string} a token string
 * @returns {string[]}
 */
function polyAtob(a) {
  let b = [];
  if (typeof atob !== 'undefined') b = atob(a);
  if (typeof Buffer !== 'undefined') b = Buffer.from(a, 'base64').toString('binary');
  return b;
}

/**
 * @param {string} token string
 * @returns {AccessTokenData} Token data JSON or null
 */
function decodeJWT(tokenValue) {

  const token = tokenValue?.split('.')[1];
  if (!token) return null;

  /** @type {(null|AccessTokenJSON)} */
  let tokenJson = null;

  const maper = (c) => `%${('00'.concat(c.charCodeAt(0).toString(16))).slice(-2)}`;
  const strArr = polyAtob(token.replace(/-/g, '+').replace(/_/g, '/')).split('').map(maper);

  let payload = null;
  try { payload = decodeURIComponent(strArr.join('')); }
  catch (e) { console.error('JWT decode error'); }
  if (!payload) return null;

  try { tokenJson = JSON.parse(payload); }
  catch (e) { console.error('JWT decode parse error'); }
  if (!tokenJson) return null;

  let expires = new Date(tokenJson.exp * 1e3);
  if (isNaN(expires.getTime())) expires = new Date(Date.now() + (2 * 36e5)); // 2h

  return {
    expires,
    userId: tokenJson.user_id,
  };
};

export {decodeJWT};
